import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import {TranslateService} from '@ngx-translate/core';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
   unsubscribe: Subject<void> = new Subject<void>();
   OF_LABEL = 'of';

   constructor(private translate: TranslateService) {
      super();

      this.getAndInitTranslations();
   }

   getAndInitTranslations() {
      this.translate.get('paginator.size').subscribe(s => this.itemsPerPageLabel = s);
      this.translate.get('paginator.next').subscribe(s => this.nextPageLabel = s);
      this.translate.get('paginator.prev').subscribe(s => this.previousPageLabel = s);
      this.translate.get('flow.of').subscribe(s => this.OF_LABEL = s);
   }

   getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
   ) => {
      if (length === 0 || pageSize === 0) {
         return `0 ${this.OF_LABEL} ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
         startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} ${
         this.OF_LABEL
      } ${length}`;
   }
}
